<div class="mb-[42px] text-lg text-[#53565b] flex items-start flex-col" >
  <p class="sm:mb-[8px] text-lg text-[#53565b] leading-5">
    Basic information and reminder
  </p>
  <p class="text-sm m-0 text-k-black">
    Description
  </p>
</div>
@if (url) {
  <section>
    <div class="w-full">
      <div
        class="w-full h-[386px] rounded-2xl"
      [class]="url">&nbsp;</div>
    </div>
  </section>
}
<div class="flex items-start justify-between pl-0 pr-0 w-full h-[65px] mt-4" >
  <button class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" (click)="back()">
    <span class="flex items-center gap-2 text-[#18191C]"
      ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
      >
    </button>
    <div
      class="w-[158px]"
      >
      <button
        type="submit"
        (click)="save()"
        class="app__btn--primary mt-0"
        >
        Continue
      </button>
    </div>
  </div>